import { useMemo } from "react";
import PropTypes from "prop-types";
import { useFilters, usePagination, useSortBy, useTable } from "react-table";

import { Table, WrapperContainer } from "../../../../components";
import { MissingKeysModalTableColumns } from "./MissingKeysModalTableColumns";

const MissingKeysModalTable = ({ missingKeys }) => {
  const columns = useMemo(() => MissingKeysModalTableColumns, []);
  const tableInstance = useTable(
    {
      columns,
      data: missingKeys
    },
    useFilters,
    useSortBy,
    usePagination
  );

  return (
    <WrapperContainer mt={24}>
      <Table
        tableInstance={tableInstance}
        maxTableHeight="186px"
        hasPagination
        showTableBorder
        modalTable
      />
    </WrapperContainer>
  );
};

MissingKeysModalTable.propTypes = {
  missingKeys: PropTypes.arrayOf(
    PropTypes.shape({
      missingKey: PropTypes.string.isRequired,
      defaultLocalization: PropTypes.string.isRequired
    })
  ).isRequired
};

export default MissingKeysModalTable;
